export type PermissionKey =
  | 'hasApprovalSeal'
  | 'hasApprovalErp'
  | 'hasApprovalSftp'
  | 'hasViewReport'
  | 'hasApprovalLeave'
  | 'hasManageLeaveBalance'
  | 'hasViewLeaveCalendar';

export type AppUser = {
  id: number;
  username?: string | null;
  name?: string | null;
  role: string;
  isSuperAdmin: boolean;

  // nên dùng Partial để tránh crash khi backend trả thiếu key nào đó
  permissions: Partial<Record<PermissionKey, boolean>>;
  pendingCounts?: {
    leave: number;
    service: number;
    erp: number;
    sftp: number;
  };
};


// QUAN TRỌNG: phải là enum thường (không phải const enum)
export enum CategoryKey {
  ALL = 'ALL',
  DOCUMENTS = 'DOCUMENTS',
  ERP = 'ERP',
  SERVICE = 'SERVICE',
  ADMIN = 'ADMIN',
}

export type MenuItem = {
  id: string;
  label: string;
  icon: string;
  href: string;
  category: Exclude<CategoryKey, CategoryKey.ALL>;
  external?: boolean;
  isSuperAdminOnly?: boolean;
  permission?: PermissionKey;
  color?: string;
  description?: string;
};

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}
